import { getTokenValue, Typography } from '@drivekyte/ui';
import React from 'react';

interface TableHeaderProps {
  isHiglighted?: boolean;
  label: string;
  totalColumns: number;
}

const TableHeader: React.FC<TableHeaderProps> = ({
  isHiglighted,
  label,
  totalColumns,
}) => (
  <th
    style={{
      backgroundColor: isHiglighted
        ? getTokenValue('$green400', 'color')
        : 'none',
      borderTopLeftRadius: getTokenValue('$large', 'radius'),
      borderTopRightRadius: getTokenValue('$large', 'radius'),
      height: '64px',
      textAlign: 'center',
      verticalAlign: 'middle',
      width: `calc(100% / ${totalColumns})`,
    }}
  >
    <Typography
      variant="headingSmall"
      color={isHiglighted ? '$contentInversePrimary' : '$contentSecondary'}
    >
      {label}
    </Typography>
  </th>
);

export default TableHeader;
